import { useEffect, useState } from 'react';
import Header from '../components/Header.jsx';
import { fmtClock, fmtTime } from '../lib/datetime.js';

export default function IdleScreen({ device, onStart, autoCloseInfo, onDismissAutoClose }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-slate-100">
      <Header deviceName={device?.name} />

      {autoCloseInfo && (
        <div className="bg-amber-100 border-b border-amber-200 px-6 py-4 flex items-start justify-between gap-4">
          <div className="text-amber-900 text-kiosk">
            <div className="font-semibold">Previous session auto-signed-out</div>
            <div className="text-base mt-1">
              CathayID{' '}
              <span className="font-mono">{autoCloseInfo.cathay_id}</span> was
              signed in for more than 4 hours
              {autoCloseInfo.signin_at_utc && (
                <> (since {fmtTime(autoCloseInfo.signin_at_utc)})</>
              )}
              . The usage has been recorded automatically.
            </div>
          </div>
          <button
            onClick={onDismissAutoClose}
            className="text-amber-900 hover:text-amber-700 text-3xl leading-none px-3 self-start"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      )}

      <main className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="text-kiosk text-slate-500 mb-2">
          You are in IPT: <span className="font-semibold text-slate-700">{device?.name || '—'}</span>
        </div>
        <div className="text-[6rem] font-mono text-cathay-700 leading-none mb-12">
          {fmtClock(now)}
        </div>
        <button
          onClick={onStart}
          className="bg-cathay-500 hover:bg-cathay-600 active:bg-cathay-700 text-white text-kiosk-xl font-semibold px-16 py-10 rounded-3xl shadow-xl transition"
        >
          Tap to sign in
        </button>
        <div className="text-kiosk text-slate-500 mt-12 text-center space-y-1">
          <div>Tap above to start your session</div>
          <div className="text-slate-400">IPT is a shared company resource for all pilots.</div>
          <div className="text-slate-400">Please cancel any unused session.</div>
        </div>
      </main>
    </div>
  );
}
